export const FETCH_COUPON_DATA = "FETCH_COUPON_DATA";
